export const GET_ENTERPRISE_ENQUIRY = "GET_ENTERPRISE_ENQUIRY";
export const GET_ENTERPRISE_ENQUIRY_SUCCESS = "GET_ENTERPRISE_ENQUIRY_SUCCESS";
export const GET_ENTERPRISE_ENQUIRY_FAILURE = "GET_ENTERPRISE_ENQUIRY_FAILURE";
export const RESET_ENTERPRISE_ENQUIRY = "RESET_ENTERPRISE_ENQUIRY";

export const getEnterpriseEnquiryRequest = (params: { fromdate: string; todate: string }) => ({
    type: GET_ENTERPRISE_ENQUIRY,
    payload: params,
});

export const getEnterpriseEnquirySuccess = (data: any) => ({
    type: GET_ENTERPRISE_ENQUIRY_SUCCESS,
    payload: data,
});

export const getEnterpriseEnquiryFailure = (error: any) => ({
    type: GET_ENTERPRISE_ENQUIRY_FAILURE,
    payload: error,
});

export const resetEnterpriseEnquiry = () => ({
    type: RESET_ENTERPRISE_ENQUIRY,
});